import { Box } from '@mui/material';
import { FC, Fragment } from 'react';
import { getVideo } from './helper';
import { BodyType } from 'components/News/types';

interface PropsTypes {
    item: BodyType;
    index: number;
    showTranslatedNews: (name: string) => string;
}
const SingleNews: FC<PropsTypes> = ({ item, showTranslatedNews, index }) => {
    const { title, points, img } = item;
    return (
        <Box className="news-modal-body-item">
            <h3>{showTranslatedNews(`body[${index}].title`) || title}</h3>
            <ul>
                {points.map((point, i) => (
                    <li key={point}>
                        {showTranslatedNews(`body[${index}].points[${i}]`) || point}
                    </li>
                ))}
            </ul>
            {Array.isArray(img) ? (
                img.map((item, i) => (
                    <Fragment key={item.key}>
                        {item.title && (
                            <ul>
                                <li key={item.title}>
                                    {showTranslatedNews(`body[${index}].img[${i}].title`) ||
                                        item.title}
                                </li>
                            </ul>
                        )}
                        <Box className="news-modal-body-item-img-container">
                            <video preload="metadata" muted controls autoPlay loop>
                                <source src={getVideo(item.key)} type="video/mp4" />
                            </video>
                        </Box>
                    </Fragment>
                ))
            ) : (
                <Box className="news-modal-body-item-img-container">
                    <video preload="metadata" muted controls autoPlay loop>
                        <source src={getVideo(img)} type="video/mp4" />
                    </video>
                </Box>
            )}
        </Box>
    );
};

export default SingleNews;
